import Lottie from 'lottie-react';
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'

import './Preview.css'
interface LottieAnimationProps {
    show: boolean,
    animationPath: string;
    onClose: () => void;
}

const FullScreenLottieAnimation: React.FC<LottieAnimationProps> = ({
    show,
    animationPath,
    onClose,
}) => {
    const [animationData, setAnimationData] = useState<string | null>(null);

    useEffect(() => {
        const fetchAnimationData = async () => {
            try {
                if (animationPath) {
                    const response = await fetch(animationPath);
                    const data = await response.json();
                    setAnimationData(data);
                }

            } catch (error) {
                console.error("Error loading animation data:", error);
            }
        };

        fetchAnimationData();
    }, [animationPath]);

    return (
        <Modal className='blurBackground' show={show} fullscreen={true} onHide={onClose}>
            <Modal.Header closeButton className='border-0' />
            <Modal.Body style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", overflow: "hidden" }}>
                <Lottie animationData={animationData} style={{ maxHeight: "70vh", maxWidth: "auto", height: "100%", width: "100%", objectFit: "contain" }} loop={true} />
            </Modal.Body>
        </Modal>
    );

}

export default FullScreenLottieAnimation